import {IUserDTO as IBaseDto, User as Base} from "frontend-core";

export class User extends Base {
    id: string;
    legacyUserId: string | null;
    isActive: boolean | null;
    onlyOnlinePay: boolean | null;

    constructor(dto?: IUserDTO)
    constructor(
        id?: string,
        legacyUserId?: string | null,
        isActive?: boolean | null,
        username?: string,
        email?: string,
        roles?: string[],
        onlyOnlinePay?: boolean,
    )
    constructor(
        idOrDto: IUserDTO | string = "",
        legacyUserId: string | null = null,
        isActive: boolean | null = true,
        username: string = "",
        email: string = "",
        roles: string[] = [],
        onlyOnlinePay: boolean | null = null,
    ) {

        if (typeof idOrDto !== "string") {
            super(idOrDto);
            this.id = idOrDto.id;
            this.legacyUserId = idOrDto.legacyUser !== null ? String(idOrDto.legacyUser) : null;
            this.isActive = idOrDto.isActive ?? null;
            this.onlyOnlinePay = idOrDto.onlyOnlinePay ?? null;
        } else {
            super(username, email, roles);
            this.id = idOrDto;
            this.legacyUserId = legacyUserId;
            this.isActive = isActive || null;
            this.onlyOnlinePay = onlyOnlinePay;
        }
    }
}

export type IUserDTO = IBaseDto & Readonly<{
    "id": string;
    "legacyUser": number | null;
    "isActive"?: boolean | null;
    "onlyOnlinePay"?: boolean | null;
}>;
